<template>
  <div
    class="resizable-panel-container"
    :class="orientation + ' ' + position"
    :style="{ width: panelStyleWidth, height: panelStyleHeight }"
    ref="resizablePanel"
    :id="panelId"
  >
    <!-- {{ panelId }}
    {{ resizerId }} -->
    <div
      class="panel-resizer"
      v-show="panelResizerVisible"
      :id="resizerId"
    ></div>
    <div
      ref="panelToggler"
      class="panel-toggler"
      v-bind:class="{ togglerMax: panelHeight == maxHeight }"
      :style="{ marginBottom: togglerMarginBottom }"
      v-show="isMobileWidth ? expanded : true"
    >
      <a
        @click="onTogglerClick"
        @keyup.enter.space="onTogglerClick"
        :title="togglerTitle"
        :tabIndex="0"
      >
        <icon :name="togglerIconName"></icon>
      </a>
    </div>
    <div class="panel-displayer" v-show="isMobileWidth ? !expanded : false">
      <b-btn @click="onTogglerClick" :title="togglerTitle" :tabIndex="0">
        <icon name="layer-group"></icon>
      </b-btn>
    </div>
    <div
      class="resizable-panel"
      v-show="!!panelHeight && !!panelWidth"
      ref="tablist"
      :style="{ visibility: panelVisibility, 'overflow-y': 'auto' }"
      role="tablist"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { toStringHDMS } from 'ol/coordinate';
import { mapGetters } from 'vuex';

export default {
  name: 'ResizablePanel',
  // created() {
  //   this.panelId = this.generatePanelId();
  //   this.resizerId = this.generateResizerId();
  //   this.createMouseResizable();
  // },
  mounted() {
    if (!this.isExpanded || this.isMobileWidth) {
      this.expanded = false;
      this.collapse();
    }
    this.panel = document.getElementById(this.panelId);
    this.panelParent = this.$el.parentElement.parentNode;
    this.createMouseResizable();
    this.observeSize();
  },
  data() {
    const id = Math.random();
    return {
      buttons: [],
      panelWidth: this.width,
      panelHeight: this.height,
      expanded: true,
      isResizing: false,
      resizer: null,
      panel: null,
      panelParent: null,
      panelId: 'panel-' + id,
      resizerId: 'resizer-panel' + id
    };
  },
  computed: {
    ...mapGetters(['isMobileWidth']),
    panelStyleWidth() {
      let panelStyleWidth = null;
      if (this.isMobileWidth) {
        if (this.isExpanded) {
          panelStyleWidth = this.mobileWidth + '%';
        } else {
          panelStyleWidth = 'auto';
        }
      } else {
        panelStyleWidth = this.panelWidth + '%';
      }
      return panelStyleWidth;
    },
    panelResizerVisible() {
      if (this.isMobileWidth) {
        return false;
      } else {
        if (
          (this.orientation == 'vertical' && this.panelWidth) ||
          (this.orientation == 'horizontal' && this.panelHeight)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    panelStyleHeight() {
      return this.panelHeight + '%';
    },
    panelVisibility() {
      switch (this.orientation) {
        case 'vertical':
          return this.panelWidth !== this.minWidth ? 'visible' : 'hidden';
        case 'horizontal':
          return this.panelHeight !== this.minHeight ? 'visible' : 'hidden';
      }

      return 'visible';
    },
    collapsible() {
      switch (this.orientation) {
        case 'vertical':
          return this.panelWidth !== this.minWidth;
        case 'horizontal':
          return this.panelHeight !== this.minHeight;
      }
    },
    expandable() {
      switch (this.orientation) {
        case 'vertical':
          return this.panelWidth !== this.maxWidth;
        case 'horizontal':
          return this.panelHeight !== this.maxHeight;
      }
    },
    togglerIconName() {
      return this.expanded
        ? this.getExpandedTogglerIconName()
        : this.getCollapsedTogglerIconName();
    },
    togglerTitle() {
      return this.expanded ? 'Zwiń' : 'Rozwiń';
    },
    togglerMarginBottom() {
      if (this.togglerMarginVertical != 0) {
        var panelTogglerHeightInEm =
          this.$refs.panelToggler.clientHeight * 0.063;
        return this.togglerMarginVertical + panelTogglerHeightInEm * 1.8 + 'em';
      }
      return this.togglerMarginVertical + 'em';
    }
  },
  props: {
    isExpanded: {
      type: Boolean,
      required: false,
      default: true
    },
    orientation: {
      type: String,
      required: true,
      validator: function(value) {
        return value === 'horizontal' || value === 'vertical';
      }
    },
    position: {
      type: String,
      required: true,
      validator: function(value) {
        let values = ['top', 'bottom', 'left', 'right'];

        return values.indexOf(value) != -1;
      }
    },

    resizingStep: {
      type: Number,
      default: 25
    },
    width: {
      type: Number,
      default: 100
    },
    mobileWidth: {
      type: Number,
      default: 100
    },
    maxWidth: {
      type: Number,
      default: 25
    },
    minWidth: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 100
    },
    maxHeight: {
      type: Number,
      default: 50
    },
    minHeight: {
      type: Number,
      default: 0
    },
    togglerMarginVertical: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onTogglerClick() {
      this.expanded ? this.collapse() : this.expand();
    },
    getExpandedTogglerIconName() {
      switch (this.position) {
        case 'left':
          return 'caret-left';
        case 'right':
          return 'caret-right';
        case 'bottom':
          return 'caret-down';
      }
    },
    getCollapsedTogglerIconName() {
      switch (this.position) {
        case 'left':
          return 'caret-right';
        case 'right':
          return 'caret-left';
        case 'bottom':
          return 'caret-up';
      }
    },
    setWider() {
      let newWidth = this.panelWidth + this.resizingStep;

      if (newWidth <= this.maxWidth) {
        this.panelWidth = newWidth;
      }

      if (newWidth === this.maxWidth) {
        this.expanded = true;
      }
    },
    setNarrower() {
      let newWidth = this.panelWidth - this.resizingStep;

      if (newWidth >= this.minWidth) {
        this.panelWidth = newWidth;
      }

      if (newWidth === this.minWidth) {
        this.expanded = false;
      }
    },
    setHigher() {
      let newHeight = this.panelHeight + this.resizingStep;

      if (newHeight <= this.maxHeight) {
        this.panelHeight = newHeight;
      }

      if (newHeight === this.maxHeight) {
        this.expanded = true;

        let coordinatesContainer = Array.from(
          document.getElementsByClassName('coordinates-container')
        );
        if (coordinatesContainer.some(x => true)) {
          coordinatesContainer[0].style.display = 'none';
        }

        this.$emit('set-lower-higher', true);
      }
    },
    setLower() {
      let newHeight = this.panelHeight - this.resizingStep;

      if (newHeight >= this.minHeight) {
        this.panelHeight = newHeight;
      }

      if (newHeight === this.minHeight) {
        this.expanded = false;
      }

      let coordinatesContainer = Array.from(
        document.getElementsByClassName('coordinates-container')
      );
      if (coordinatesContainer.some(x => true)) {
        coordinatesContainer[0].style.display = 'block';
      }

      this.$emit('set-lower-higher', false);
    },
    expand() {
      switch (this.orientation) {
        case 'vertical':
          this.setWider();
          break;
        case 'horizontal':
          this.setHigher();
          break;
      }
    },
    collapse() {
      switch (this.orientation) {
        case 'vertical':
          this.setNarrower();
          break;
        case 'horizontal':
          this.setLower();
          break;
      }
    },
    createMouseResizable() {
      this.resizer = document.getElementById(this.resizerId);

      this.resizer.addEventListener('mousedown', event => {
        this.isResizing = true;

        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', () => {
          this.isResizing = false;
          document.removeEventListener('mousemove', this.handleMouseMove);
        });
      });
    },
    handleMouseMove(event) {
      if (this.isResizing) {
        switch (this.position) {
          case 'left':
            if (
              (this.panel.offsetWidth / this.panelParent.offsetWidth) * 100 >
                this.maxWidth &&
              event.x + this.resizer.style.width > this.panel.style.width
            ) {
              this.expanded = true;
              this.panelWidth = this.maxWidth;
            } else if (
              (this.panel.offsetWidth / this.panelParent.offsetWidth) * 100 <
              this.minWidth + 1
            ) {
              this.expanded = false;
              this.panelWidth = this.minWidth;
            } else {
              this.panel.style.width = `${event.x}px`;
              this.expanded = true;
              if (this.panelWidth == this.minWidth) {
                this.panelWidth = this.minWidth + 1;
              }
            }
            break;
          case 'right':
            if (
              (this.panel.offsetWidth / this.panelParent.offsetWidth) * 100 >
                this.maxWidth &&
              this.panelParent.offsetWidth -
                event.x +
                this.resizer.style.width >
                this.panel.style.width
            ) {
              this.expanded = true;
              this.panelWidth = this.maxWidth;
            } else if (
              (this.panel.offsetWidth / this.panelParent.offsetWidth) * 100 <
              this.minWidth + 1
            ) {
              this.expanded = false;
              this.panelWidth = this.minWidth;
            } else {
              this.panel.style.width = `${this.panelParent.offsetWidth -
                event.x}px`;
              this.expanded = true;
              if (this.panelWidth == this.minWidth) {
                this.panelWidth = this.minWidth + 1;
              }
            }
            break;
          case 'bottom':
            if (
              (this.panel.offsetHeight / this.panelParent.offsetHeight) * 100 >
                this.maxHeight &&
              event.y + this.resizer.style.height > this.panel.style.height
            ) {
              this.expanded = true;
              this.panelHeight = this.maxHeight;
            } else if (
              (this.panel.offsetHeight / this.panelParent.offsetHeight) * 100 <
              this.minHeight + 1
            ) {
              this.expanded = false;
              this.panelHeight = this.minHeight;
            } else {
              this.panel.style.height = `${this.panelParent.offsetHeight -
                event.y +
                this.panelParent.getBoundingClientRect().y}px`;
              this.expanded = true;
              if (this.panelHeight == this.minHeight) {
                this.panelHeight = this.minHeight + 1;
              }
            }
            break;
        }
      }
    },
    observeSize() {
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const width = Math.round(entry.borderBoxSize[0].inlineSize);
          const height = Math.round(entry.borderBoxSize[0].blockSize);
          this.$emit('panel-resized', {
            width,
            height
          });
        }
      });

      resizeObserver.observe(this.$refs.resizablePanel);
    }
  },
  watch: {
    isExpanded: function(newValue, oldValue) {
      if (!this.isResizing) {
        if (newValue == true) {
          this.expanded = true;
          this.expand();
        } else {
          this.expanded = false;
          this.collapse();
        }
      }
    },
    expanded: function(newValue, oldValue) {
      this.$emit('expanded-changed', newValue);
    }
  }
};
</script>
